var others =
    [
        {
            "id": 13,
            "title": "Cognitive Behavioural Therapy (CBT) Practitioner Certificate",
            "author": "Kain Ramsay",
            "email": "ramsayacademy@yahoo.com",
            "description": "Learn Cognitive Behavioural Therapy (CBT) and how you can positively influence peoples emotional and mental well-being.",
            "rating": 4.5,
            "level": "All",
            "lecture": 362,
            "hours": 10,            
            "address": {
              "street": "california",
              "city": "united kingdom",
              "geo": {
                "lat": "-27.3159",
                "lng": "11.1496"
              }
            },
            "phone": "123-456-789-00",
            "website": "AchologyLtd.com",
            "language": "English",
            "students": 116589,
            "price": 222.99,
            "image": "https://img-a.udemycdn.com/course/480x270/1091520_9b90_10.jpg",
          },
          {
            "id": 14,
            "title": "Learn Meditation with Certification to Guide Others",
            "author": "Melissa Crowhurst",
            "email": "Crowhurst209@yahoo.com",
            "description": "Learn meditation for stress relief, mindfulness, anxiety & more! Includes 10 guided audios & Meditation Certificate",
            "rating": 4.6,
            "level": "Master",
            "lecture": 222,
            "hours": 12,            
            "address": {
              "street": "california",
              "city": "united kingdom",
              "geo": {
                "lat": "-67.3159",
                "lng": "01.1496"
              }
            },
            "phone": "123-456-789-00",
            "website": "crowhurstcharity.com",
            "language": "English",
            "students": 15290,
            "price": 122.99,
            "image": "http://suprkit.com/assets/images/other/course-7.jpg",
          }, 
          {
            "id": 15,
            "title": "The Secrets to Drawing",
            "author": "Matthew Fussell",
            "email": "fussell@gmail.com",
            "description": "A comprehensive video and ebook course designed for people wanting to learn the core concepts of drawing.",
            "rating": 4.5,
            "level": "All",
            "lecture": 55,
            "hours": 2,            
            "address": {
              "street": "california",
              "city": "united kingdom",
              "geo": {
                "lat": "-67.3159",
                "lng": "01.1496"
              }
            },
            "phone": "123-456-789-00",
            "website": "crowhurstcharity.com",
            "language": "English",
            "students": 31225,
            "price": 119.99,
            "image": "http://suprkit.com/assets/images/other/course-2.jpg",
          },   
          {
            "id": 16,
            "title": "How to Draw From Beginner to Master",
            "author": "Joseph Patric Daniels",
            "email": "daniels2019@gmail.com",
            "description": "Drawing and Shading From Fundamentals to Photorealism",
            "rating": 4.7,
            "level": "All",
            "lecture": 121,
            "hours": 11,            
            "address": {
              "street": "california",
              "city": "united kingdom",
              "geo": {
                "lat": "-67.3159",
                "lng": "01.1496"
              }
            },
            "phone": "897-456-789-00",
            "website": "danielsart.com",
            "language": "English",
            "students": 20879,
            "price": 89.99,
            "image": "http://suprkit.com/assets/images/other/course-1.jpg",
          }, 
          {
            "id": 17,
            "title": "Management Skills: New Manager Training in Essential Skills",
            "author": "Lawrence M. Miller",
            "email": "millerlawrence@gmail.com",
            "description": "Management Skills Certification in Developing People, Leading Teams & Process Improvement",
            "rating": 4.3,
            "level": "All",
            "lecture": 411,
            "hours": 22,            
            "address": {
              "street": "california",
              "city": "united kingdom",
              "geo": {
                "lat": "-67.3159",
                "lng": "01.1496"
              }
            },
            "phone": "556-456-789-00",
            "website": "danielsart.com",
            "language": "English",
            "students": 34529,
            "price": 134.99,
            "image": "http://suprkit.com/assets/images/other/course-4.jpg",
          }, 
          {
            "id": 18,
            "title": "Pianoforall - Incredible New Way To Learn Piano & Keyboard",
            "author": "Robil a Hall",
            "email": "robinhall2@gmail.com",
            "description": "Learn Piano in WEEKS not years. Play-By-Ear & learn to Read Music. Pop, Blues, Jazz, Ballads, Improvisation, Classical",
            "rating": 4.5,
            "level": "Master",
            "lecture": 112,
            "hours": 112,
            "address": {
              "street": "dhaka",
              "city": "Bangladesh",
              "geo": {
                "lat": "-47.3159",
                "lng": "21.1496"
              }
            },
            "phone": "223-456-789-00",
            "website": "robinhallmusic.com",
            "language": "English",
            "students": 271118,
            "price": 159.99,
            "image": "https://img-a.udemycdn.com/course/480x270/238934_4d81_5.jpg",
          },   
          {
            "id": 20,
            "title": "How to get your kids to cooperate-even if they don't want to",
            "author": "Robin Booth",
            "email": "robinhall2@gmail.com",
            "description": "Avoid the shouting, threats, and bribes with these Emotionally Intelligent skills and boundaries - (toddler to teen).",
            "rating": 4.4,
            "level": "Intermediate",
            "lecture": 30,
            "hours": 5,
            "address": {
              "street": "dhaka",
              "city": "Bangladesh",
              "geo": {
                "lat": "-47.3159",
                "lng": "21.1496"
              }
            },
            "phone": "223-456-789-00",
            "website": "robinhallmusic.com",
            "language": "English",
            "students": 9987,
            "price": 89.99,
            "image": "https://img-a.udemycdn.com/course/480x270/319042_97b9_7.jpg",
          }                                             
    ];

export default others;